import React from 'react';
import { LinkData } from '../types';

interface Props {
  config: Record<string, any>;
  links: LinkData[];
}

const GRADIENTS = ['#3ecf8e,#14b8a6', '#f59e0b,#ef4444', '#8b5cf6,#ec4899', '#06b6d4,#3b82f6'];

export const RichArticleCards: React.FC<Props> = ({ config, links }) => {
  // Use correct field names from types.ts
  const {
    moduleHeading = 'You Might Also Like',
    layout = 'grid',
    gridColumns = '3',
    showImage = true,
    showCategory = true,
    showReadingTime = true,
    showExcerpt = true,
    showDate = false,
  } = config;

  const cols = parseInt(gridColumns, 10) || 3;

  return (
    <div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <h2
        style={{ color: '#1e3a5f', marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600, margin: '0 0 1rem 0' }}
      >
        {moduleHeading}
      </h2>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: '1.5rem' }}>
        {links.map((link, i) => {
          const gradient = GRADIENTS[i % GRADIENTS.length];
          return (
            <article
              key={i}
              style={{
                background: 'white',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              }}
            >
              {showImage && (
                <a
                  href={link.url}
                  style={{
                    display: 'block',
                    height: '180px',
                    overflow: 'hidden',
                    background: link.image ? `url(${link.image}) center/cover` : `linear-gradient(135deg, ${gradient})`,
                  }}
                >
                  {link.image && (
                    <img
                      src={link.image}
                      alt={link.title || ''}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  )}
                </a>
              )}
              <div style={{ padding: '1rem' }}>
                {showCategory && (
                  <span
                    style={{
                      display: 'inline-block',
                      fontSize: '0.75rem',
                      color: '#2db77a',
                      fontWeight: 500,
                      textTransform: 'uppercase',
                      marginBottom: '0.5rem',
                    }}
                  >
                    {link.category || 'Article'}
                  </span>
                )}
                {showReadingTime && (
                  <span style={{ fontSize: '0.75rem', color: '#94a3b8', marginLeft: '0.5rem' }}>
                    {link.readingTime || '5 min read'}
                  </span>
                )}
                <a
                  href={link.url}
                  style={{
                    display: 'block',
                    color: '#1e3a5f',
                    fontWeight: 600,
                    textDecoration: 'none',
                    marginBottom: '0.5rem',
                  }}
                >
                  {link.title || link.anchorText || link.url}
                </a>
                {showExcerpt && link.description && (
                  <p
                    style={{
                      color: '#64748b',
                      fontSize: '0.9rem',
                      lineHeight: 1.5,
                      marginBottom: '0.5rem',
                      margin: '0 0 0.5rem',
                    }}
                  >
                    {link.description}
                  </p>
                )}
                {showDate && link.publishDate && (
                  <time style={{ color: '#94a3b8', fontSize: '0.8rem' }}>{link.publishDate}</time>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};
